const maxRadiusVendorCategories = {
    MORE_ELIGIBLE: 'more_eligible',
    NON_ELIGIBLE: 'non_eligible',
    SRA: 'sra'
};
Object.freeze(maxRadiusVendorCategories);
export default maxRadiusVendorCategories;